// Modern Currency Switcher with Geolocation
// File: assets/currency-switcher.js

(function() {
  'use strict';
  
  console.log('[Currency Switcher] Script loaded');
  
  if (document.readyState === 'loading') {
    console.log('[Currency Switcher] DOM not ready, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', initCurrencySwitcher);
  } else {
    console.log('[Currency Switcher] DOM ready, initializing immediately');
    initCurrencySwitcher();
  }
  
  async function initCurrencySwitcher() {
    console.log('[Currency Switcher] initCurrencySwitcher() called');
    
    // Skip automatic currency detection in Theme Editor to prevent refresh loop
    if (window.Shopify && window.Shopify.designMode) {
      console.log('[Currency Switcher] Design mode detected, skipping initialization');
      return;
    }
    
    const currencySwitcher = document.getElementById('currency-switcher');
    const currentFlag = document.getElementById('current-flag');
    
    if (!currencySwitcher || !currentFlag) {
      console.log('[Currency Switcher] Required elements not found:', {
        currencySwitcher: !!currencySwitcher,
        currentFlag: !!currentFlag
      });
      return;
    }
    
    console.log('[Currency Switcher] Elements found, checking user preference');
    
    // Check if user has already selected a currency
    const hasUserPreference = getShopifyCookie('localization');
    console.log('[Currency Switcher] localization cookie:', hasUserPreference);
    
    // Check URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const hasCurrencyParam = urlParams.has('currency');
    console.log('[Currency Switcher] URL currency param:', urlParams.get('currency'));
    
    if (!hasUserPreference && !hasCurrencyParam) {
      console.log('[Currency Switcher] No preference found, starting auto-detection');
      // First-time visitor: detect location and set currency
      await detectAndSetCurrency();
    } else {
      console.log('[Currency Switcher] Preference exists, skipping auto-detection');
    }
    
    // Get current currency from Shopify
    const currentCurrency = getCurrentCurrency();
    console.log('[Currency Switcher] Current currency:', currentCurrency);
    
    if (currentCurrency && currencySwitcher.querySelector(`option[value="${currentCurrency}"]`)) {
      currencySwitcher.value = currentCurrency;
      updateFlag(currentCurrency);
      console.log('[Currency Switcher] UI updated to:', currentCurrency);
    }
    
    // Handle currency switching
    currencySwitcher.addEventListener('change', async function(e) {
      const selectedCurrency = e.target.value;
      console.log('[Currency Switcher] User selected:', selectedCurrency);
      
      // Optimistic UI update (instant feedback)
      updateFlag(selectedCurrency);
      currencySwitcher.disabled = true;
      
      // Submit to Shopify's localization endpoint
      await changeCurrency(selectedCurrency);
      
      currencySwitcher.disabled = false;
    });
    
    console.log('[Currency Switcher] Initialization complete');
  }
  
  async function detectAndSetCurrency() {
    console.log('[Currency Switcher] detectAndSetCurrency() called');
    
    try {
      // Use Shopify's built-in country detection if available
      console.log('[Currency Switcher] Checking Shopify.country:', window.Shopify?.country);
      
      if (window.Shopify && window.Shopify.country) {
        const country = window.Shopify.country;
        const currency = getDefaultCurrencyForCountry(country);
        console.log('[Currency Switcher] Shopify country detected:', country, '-> currency:', currency);
        if (currency) {
          await changeCurrency(currency, true);
          return;
        }
      }
      
      // Fallback: Use Cloudflare's geolocation (free, fast, no API key needed)
      console.log('[Currency Switcher] Trying Cloudflare geolocation...');
      const response = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
      console.log('[Currency Switcher] Cloudflare response status:', response.status);
      
      const data = await response.text();
      console.log('[Currency Switcher] Cloudflare data:', data);
      
      const countryMatch = data.match(/loc=([A-Z]{2})/);
      
      if (countryMatch) {
        const country = countryMatch[1];
        const currency = getDefaultCurrencyForCountry(country);
        console.log('[Currency Switcher] Cloudflare country:', country, '-> currency:', currency);
        if (currency) {
          await changeCurrency(currency, true);
        }
      } else {
        console.log('[Currency Switcher] No country match in Cloudflare data');
      }
    } catch (error) {
      console.log('[Currency Switcher] Geolocation detection error:', error);
      // Fallback to GBP if geolocation fails
      console.log('[Currency Switcher] Falling back to GBP');
      await changeCurrency('GBP', true);
    }
  }
  
  function getDefaultCurrencyForCountry(countryCode) {
    // GBP only for UK, EUR for all other countries
    if (countryCode === 'GB') {
      return 'GBP';
    }
    
    // All other countries get EUR
    return 'EUR';
  }
  
  async function changeCurrency(currency, isAutoDetection = false) {
    console.log('[Currency Switcher] changeCurrency() called:', currency, 'isAutoDetection:', isAutoDetection);
    
    try {
      // Update Shopify's localization via official endpoint
      const formData = new FormData();
      formData.append('currency_code', currency);
      formData.append('return_to', window.location.pathname + window.location.search);
      
      console.log('[Currency Switcher] POSTing to /localization...');
      const response = await fetch('/localization', {
        method: 'POST',
        body: formData
      });
      console.log('[Currency Switcher] /localization response status:', response.status);
      
      // Reload with currency parameter for immediate visual update
      const url = new URL(window.location.href);
      url.searchParams.set('currency', currency);
      
      console.log('[Currency Switcher] Redirecting to:', url.toString());
      
      // For auto-detection on first load, use replace to avoid back button issues
      if (isAutoDetection) {
        console.log('[Currency Switcher] Using location.replace()');
        window.location.replace(url.toString());
      } else {
        console.log('[Currency Switcher] Using location.href');
        window.location.href = url.toString();
      }
      
    } catch (error) {
      console.error('[Currency Switcher] Currency switch failed:', error);
      // Fallback: direct URL change
      const url = new URL(window.location.href);
      url.searchParams.set('currency', currency);
      console.log('[Currency Switcher] Fallback redirect to:', url.toString());
      window.location.href = url.toString();
    }
  }
  
  async function updatePricesOnPage(currency) {
    // For instant visual feedback, update the money elements
    // This works with Shopify's standard money format elements
    const moneyElements = document.querySelectorAll('[data-currency-' + currency.toLowerCase() + ']');
    
    moneyElements.forEach(el => {
      const newPrice = el.dataset['currency' + currency.toLowerCase()];
      if (newPrice) {
        el.textContent = newPrice;
      }
    });
  }
  
  function getCurrentCurrency() {
    // Try Shopify's active currency first
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      console.log('[Currency Switcher] getCurrentCurrency() from Shopify.currency.active');
      return window.Shopify.currency.active.toUpperCase();
    }
    
    // Check Shopify's localization cookie
    const localizationCookie = getShopifyCookie('localization');
    if (localizationCookie) {
      try {
        const parsed = JSON.parse(decodeURIComponent(localizationCookie));
        if (parsed.currency) {
          console.log('[Currency Switcher] getCurrentCurrency() from cookie');
          return parsed.currency.toUpperCase();
        }
      } catch (e) {
        // Invalid JSON, continue to fallback
      }
    }
    
    // Check URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const urlCurrency = urlParams.get('currency');
    if (urlCurrency) {
      console.log('[Currency Switcher] getCurrentCurrency() from URL param');
      return urlCurrency.toUpperCase();
    }
    
    // Default to GBP
    console.log('[Currency Switcher] getCurrentCurrency() defaulting to GBP');
    return 'GBP';
  }
  
  function updateFlag(currency) {
    const currencySwitcher = document.getElementById('currency-switcher');
    const currentFlag = document.getElementById('current-flag');
    
    if (!currencySwitcher || !currentFlag) return;
    
    const option = currencySwitcher.querySelector(`option[value="${currency}"]`);
    if (option && option.dataset.imgUrl) {
      currentFlag.src = option.dataset.imgUrl;
      currentFlag.alt = `${currency} flag`;
    }
  }
  
  function getShopifyCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
})();